import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "img-verify"
};
const _hoisted_2 = ["width", "height"];
import { reactive, onMounted, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ImgVerify',
  props: {
    imgCode: {
      type: String,
      default: ''
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: __emit
  }) {
    const verify = ref({});
    const state = reactive({
      pool: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
      width: 180,
      height: 40,
      imgCode: ''
    });
    const props = __props;
    const emit = __emit;
    onMounted(() => {
      // 初始化绘制图片验证码
      if (props.imgCode) {
        state.imgCode = props.imgCode;
        drawWithCode(props.imgCode);
      } else {
        state.imgCode = draw();
      }
    });
    // 点击图片重新绘制
    const handleDraw = () => {
      if (props.imgCode) {
        drawWithCode(props.imgCode);
      } else {
        state.imgCode = draw();
      }
    };
    // 随机数
    const randomNum = (min, max) => {
      return Math.floor(Math.random() * (max - min) + min);
    };
    // 随机颜色
    const randomColor = (min, max) => {
      const r = randomNum(min, max);
      const g = randomNum(min, max);
      const b = randomNum(min, max);
      return `rgb(${r},${g},${b})`;
    };
    // 绘制背景
    const drawBackground = ctx => {
      ctx.fillStyle = randomColor(180, 230);
      ctx.fillRect(0, 0, state.width, state.height);
    };
    // 绘制文字
    const drawText = (ctx, text, index) => {
      const fontSize = randomNum(18, 40);
      const deg = randomNum(-30, 30);
      ctx.font = `${fontSize}px Verdana Tahoma Consolas`;
      ctx.textBaseline = 'top';
      ctx.fillStyle = randomColor(80, 150);
      ctx.save();
      ctx.translate(30 * index + 15, 15);
      ctx.rotate(deg * Math.PI / 180);
      ctx.fillText(text, -10, -10);
      ctx.restore();
    };
    // 绘制干扰线
    const drawInterferenceLines = ctx => {
      for (let i = 0; i < 5; i++) {
        ctx.beginPath();
        ctx.moveTo(randomNum(0, state.width), randomNum(0, state.height));
        ctx.lineTo(randomNum(0, state.width), randomNum(0, state.height));
        ctx.strokeStyle = randomColor(180, 230);
        ctx.closePath();
        ctx.stroke();
      }
    };
    // 绘制干扰点
    const drawInterferenceDots = ctx => {
      for (let i = 0; i < 40; i++) {
        ctx.beginPath();
        ctx.arc(randomNum(0, state.width), randomNum(0, state.height), 1, 0, 2 * Math.PI);
        ctx.closePath();
        ctx.fillStyle = randomColor(150, 200);
        ctx.fill();
      }
    };
    // 使用指定验证码绘制图片
    const drawWithCode = code => {
      const ctx = verify.value.getContext('2d');
      drawBackground(ctx);
      Array.from(code).forEach((text, i) => {
        drawText(ctx, text, i);
      });
      drawInterferenceLines(ctx);
      drawInterferenceDots(ctx);
    };
    // 绘制图片
    const draw = () => {
      const ctx = verify.value.getContext('2d');
      drawBackground(ctx);
      let imgCode = '';
      const values = new Uint32Array(4);
      window.crypto.getRandomValues(values);
      Array.from(values).map((v, i) => {
        const text = state.pool[v % state.pool.length];
        imgCode += text;
        drawText(ctx, text, i);
      });
      drawInterferenceLines(ctx);
      drawInterferenceDots(ctx);
      emit('success', imgCode.toLocaleUpperCase());
      return imgCode;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("canvas", {
        ref_key: "verify",
        ref: verify,
        width: state.width,
        height: state.height,
        onClick: handleDraw
      }, null, 8, _hoisted_2)]);
    };
  }
});